import React from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

export const LoadingData = ({
	show,
	onComplete,
	title,
	expiredText,
	text1,
	text2,
	duration,
	colors,
	colorsTime,
}) => {
	const renderTime = ({ remainingTime }) => {
		if (remainingTime === 0) {
			return <div className="timer">{expiredText || "Ready"}</div>;
		}

		return (
			<div className="flex flex-col justify-center text-center">
				<div className="text-base text-slate-400">{text1 || "Remaining"}</div>
				<div className="text-xl text-slate-800">{remainingTime}</div>
				<div className="text-base text-slate-400">{text2 || "seconds"}</div>
			</div>
		);
	};

	return (
		<div className={"flex flex-grow flex-col px-2 md:px-0 text-center"}>
			<h2 className={"text-2xl pt-6 pb-1 font-bold mb-2 text-center"}>
				{title || "Preparing your data"}
			</h2>

			<div className="mt-2">
				Please wait a few seconds while we set everything up for you.
			</div>

			<div
				className={
					"flex flex-grow overflow-y-auto px-6 pt-2 sm:px-8 sm:pt-4 pb-28 mt-8 justify-center"
				}
			>
				<CountdownCircleTimer
					isPlaying
					duration={duration || 5}
					colors={colors || ["#FF0000", "#FF6600", "#33CC33"]}
					colorsTime={colorsTime || [5, 3, 0]}
					onComplete={onComplete}
				>
					{renderTime}
				</CountdownCircleTimer>
			</div>
		</div>
	);
};
